import { CommonModule } from '@angular/common';
import { Component, HostBinding } from '@angular/core';
import { RadioComponentDef } from '@df/ui/form/radio/radio.component.def';

@Component({
    selector: 'radio',
    templateUrl: 'radio.html',
    standalone: true,
    imports: [CommonModule]
})
export class RadioComponent extends RadioComponentDef {
    @HostBinding('class.radio')
    getBaseClass = true;
}
